import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_3'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
